export default __webpack_public_path__ + "static/media/information.d9c03be3.svg";